export default function GoalAssessment({ value, onChange, initialGoal = "" }) {
  const update = (key, next) => onChange({ ...value, [key]: next });
  return <section className="rounded-xl border border-slate-600 p-4 space-y-3" aria-label="Goal assessment">
    <h3 className="font-semibold">Evidence for this goal</h3>
    <p className="text-sm">Record what the pupil demonstrated. This assessment stays with the named goal and does not choose their challenge level.</p>
    {!value ? <button type="button" className="min-h-11 underline" onClick={() => onChange({
      goal: initialGoal, status: "", observation: "", context: "", understanding: "", next_step: "",
    })}>Add my goal assessment</button> : <>
      <label className="block">Named goal
        <input className="block w-full rounded p-2 text-slate-900" value={value.goal} maxLength={240}
          onChange={(event) => update("goal", event.target.value)} />
      </label>
      <fieldset><legend>Your assessment</legend>
        {[['no_current_concern', 'No current concern'], ['needs_practice', 'Needs more practice']].map(([status, label]) =>
          <button key={status} type="button" aria-pressed={value.status === status}
            className={`min-h-11 rounded border px-3 m-1 ${value.status === status ? 'bg-blue-700 text-white' : ''}`}
            onClick={() => update("status", status)}>{label}</button>)}
      </fieldset>
      {[["observation", "What did you observe?", 600], ["context", "In what situation?", 300],
        ["understanding", "What did the pupil understand or find unclear?", 600],
        ["next_step", "Suggested next step (required for more practice)", 400]].map(([key, label, limit]) =>
          <label key={key} className="block">{label}
            <textarea className="block w-full rounded p-2 text-slate-900" rows={2} value={value[key]} maxLength={limit}
              onChange={(event) => update(key, event.target.value)} />
          </label>)}
      <p className="text-sm">Saved with the lesson and shared when you release its feedback. General praise does not confirm other goals.</p>
      <button type="button" className="min-h-11 underline" onClick={() => onChange(null)}>Remove this draft assessment</button>
    </>}
  </section>;
}
